import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getOrderList, updateOrder } from "../../store/slice/ordersSlice";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const DeleteOrderModal = ({
  deleteModal,
  setDeleteModal,
  deleteId,
  setDeleteId,
  handleDeleteModalClose,
  orderDate,
  orderStatusFilter,
  pageNumber,
  totalCount,
}) => {
  const showHideClassName = deleteModal && "user_detail_modal_show";
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const deleteOrder = () => {
    const data = {
      delete_status: "1",
    };
    dispatch(
      updateOrder({
        data,
        id: deleteId,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            setDeleteModal(false);
            setDeleteId("");
            toast.error(t("toast.delete_order"), {
              autoClose: 3000,
            });
            if (
              totalCount &&
              totalCount[totalCount?.length - 1] == 1 &&
              +pageNumber !== 1
            ) {
              navigate(`/order/page/${pageNumber - 1}`);
            }
            dispatch(
              getOrderList({
                start: (pageNumber - 1) * 10,
                limit: 10,
                order_status: orderStatusFilter,
                order_date: orderDate && moment(orderDate).format("YYYY-MM-DD"),
              })
            );
          }
        },
      })
    );
  };
  return (
    <>
      <div
        className={`user_detail_modal_bg ${showHideClassName}`}
        onClick={handleDeleteModalClose}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            {t("modal.delete.delete_order")}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.delete_order_desc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
              onClick={handleDeleteModalClose}
            >
              {t("common.close")}
            </button>

            <button
              type="button"
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
              onClick={deleteOrder}
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteOrderModal;
